export const ALL_PROVIDER_TYPES_ROUTE = {
  get: '/provider-types',
};
export const PROVIDER_TYPES_ROUTE = {
  get: '/provider-types/{provider_category_id}',
};
export const PROVIDER_CATEGORIES_ROUTE = {
  get: '/provider-categories',
};
export const PROVIDER_DETAILS_ROUTE = {
  get: '/provider-details',
};
